import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EditEmailIcon = props => /*#__PURE__*/_jsxs("svg", {
  className: "TombacIcon",
  width: "24",
  height: "24",
  viewBox: "0 -4 24 24",
  ...props,
  "data-sentry-element": "svg",
  "data-sentry-component": "EditEmailIcon",
  "data-sentry-source-file": "EditEmailIcon.tsx",
  children: [/*#__PURE__*/_jsx("path", {
    d: "m20 2v12h-16v-12zm-2 3.17-6.02 5.147-5.98-5.139v6.822h12zm-1.71-1.17h-8.592l4.286 3.683z",
    fill: "currentColor",
    mask: "url(#pen)",
    "data-sentry-element": "path",
    "data-sentry-source-file": "EditEmailIcon.tsx",
    "data-sentry-element": "path"
  }), /*#__PURE__*/_jsxs("mask", {
    id: "pen",
    "data-sentry-element": "mask",
    "data-sentry-source-file": "EditEmailIcon.tsx",
    "data-sentry-element": "mask",
    children: [/*#__PURE__*/_jsx("rect", {
      x: "0",
      y: "0",
      width: "100%",
      height: "100%",
      fill: "white",
      "data-sentry-element": "rect",
      "data-sentry-source-file": "EditEmailIcon.tsx",
      "data-sentry-element": "rect"
    }), /*#__PURE__*/_jsx("g", {
      transform: "scale(0.5) translate(25,16)",
      "data-sentry-element": "g",
      "data-sentry-source-file": "EditEmailIcon.tsx",
      "data-sentry-element": "g",
      children: /*#__PURE__*/_jsx("path", {
        d: "m4 12.7077v3.292h3.292l9.708-9.708-3.292-3.292zm15.751-9.266a0.848 0.848 0 0 0 0-1.2l-1.992-1.993a0.848 0.848 0 0 0-1.2 0l-1.559 1.558 3.193 3.193z",
        stroke: "black",
        strokeWidth: "6",
        "data-sentry-element": "path",
        "data-sentry-source-file": "EditEmailIcon.tsx",
        "data-sentry-element": "path"
      })
    })]
  }), /*#__PURE__*/_jsx("g", {
    transform: "scale(0.5) translate(25,16)",
    "data-sentry-element": "g",
    "data-sentry-source-file": "EditEmailIcon.tsx",
    "data-sentry-element": "g",
    children: /*#__PURE__*/_jsx("path", {
      d: "m4 12.7077v3.292h3.292l9.708-9.708-3.292-3.292zm15.751-9.266a0.848 0.848 0 0 0 0-1.2l-1.992-1.993a0.848 0.848 0 0 0-1.2 0l-1.559 1.558 3.193 3.193z",
      fill: "currentColor",
      "data-sentry-element": "path",
      "data-sentry-source-file": "EditEmailIcon.tsx",
      "data-sentry-element": "path"
    })
  })]
});